import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { accountService } from "../../_services";
import moment from "moment";
import "./List.css";
import axios from "axios";
import { toast } from "../../_components/Toast";
import config from "../../_helpers/config";
import AddUserPopup from "./AddUserPopup";

function List({ match }) {
  const { path } = match;
  const [users, setUsers] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filterBy, setFilterBy] = useState("");
  const [filterValue, setFilterValue] = useState("");

  const token = sessionStorage.getItem("jwtToken") || sessionStorage.getItem("jwtDLAuth") || sessionStorage.getItem("userData").token;;
  const userData = JSON.parse(sessionStorage.getItem("userData"));
  console.log(userData);

  // Subscription API functions using axios
  const subscriptionAPI = {
    // Get all subscriptions
    getAllSubscriptions: async () => {
      try {
        const response = await axios.get(
          `${config.AUTH_API_SERVER}/subscriptions/subscriptions/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching subscriptions:", error);
        throw error;
      }
    },

    // Get subscription by ID
    getSubscriptionById: async (id) => {
      try {
        const response = await axios.get(
          `${config.AUTH_API_SERVER}/subscriptions/subscriptions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error fetching subscription:", error);
        throw error;
      }
    },

    // Create new subscription
    createSubscription: async (subscriptionData) => {
      try {
        const response = await axios.post(
          `${config.AUTH_API_SERVER}/subscriptions/subscriptions`,
          subscriptionData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error creating subscription:", error);
        throw error;
      }
    },

    // Update subscription
    updateSubscription: async (id, subscriptionData) => {
      try {
        const response = await axios.patch(
          `${config.AUTH_API_SERVER}/subscriptions/subscriptions/${id}`,
          subscriptionData,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error updating subscription:", error);
        throw error;
      }
    },

    // Delete subscription
    deleteSubscription: async (id) => {
      try {
        const response = await axios.delete(
          `${config.AUTH_API_SERVER}/subscriptions/subscriptions/${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        return response.data;
      } catch (error) {
        console.error("Error deleting subscription:", error);
        throw error;
      }
    },
  };

  // New states for Plan modal
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [planName, setPlanName] = useState("");
  const [planList, setPlanList] = useState([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(false);
  const [showAddPlanForm, setShowAddPlanForm] = useState(false);
  const [deletingPlanId, setDeletingPlanId] = useState(null);
  const [showPlanDeleteDialog, setShowPlanDeleteDialog] = useState(false);
  const [planToDelete, setPlanToDelete] = useState(null);
  const [editingPlan, setEditingPlan] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  // State for plans used in the main list display
  //const [planList, setPlanList] = useState([]); // Add this state for tracking which plan is being deleted

  // New states for Subscription modal
  const [showSubModal, setShowSubModal] = useState(false);
  const [subscriptions, setSubscriptions] = useState([
    { id: 1, planId: "", durations: [{ id: 1, duration: "", price: "" }] },
  ]);
  const [showAddSubForm, setShowAddSubForm] = useState(false); // For toggling between list and add form
  const [existingSubscriptions, setExistingSubscriptions] = useState([]);
  const [isLoadingSubs, setIsLoadingSubs] = useState(false);
  const [deletingSubId, setDeletingSubId] = useState(null);
  const [showSubDeleteDialog, setShowSubDeleteDialog] = useState(false);
  const [subToDelete, setSubToDelete] = useState(null);
  const [editingSub, setEditingSub] = useState({ frequency: "monthly" });
  const [isEditModeSub, setIsEditModeSub] = useState(false);

  const [showAddUserModal, setShowAddUserModal] = useState(false);

  const [modules, setModules] = useState({
    digitalSignage: { enabled: false },
    screens: { enabled: false, count: "1" },
    playlist: { enabled: false, count: "1" },
    templates: { enabled: false, count: "1" },
    schedules: { enabled: false, count: "1" },
    basicReports: { enabled: false },
    advanceReports: { enabled: false },
    media: { enabled: false, storage: "", storageUnit: "MB" },
    restaurantSolution: { enabled: false },
    pos: { enabled: false },
    inventoryManagement: { enabled: false },
    selfOrderKiosk: { enabled: false },
    selfOrderQR: { enabled: false },
    ttoApp: { enabled: false },
    ttoQR: { enabled: false },
    advanceReports: { enabled: false },
    members: { enabled: false },
    customers: { enabled: false },
    multikitchen: { enabled: false }
  });

  const fetchUsers = () => {
    accountService.getAll().then((x) => setUsers(x));
  };

  // Fetch users initially
  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchPlans = async () => {
    try {
      const response = await axios.get(
        `${config.AUTH_API_SERVER}/plan`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setPlanList(response.data || []);
    } catch (error) {
      console.error("Error fetching plans for display:", error);
      setPlanList([]);
    }
  };

  const fetchSubs = async () => {
    try {
      // Fetch existing subscriptions
      const response = await subscriptionAPI.getAllSubscriptions();
      console.log("Fetched subscriptions:", response);
      setExistingSubscriptions(response || []);
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      toast.error("Failed to load subscriptions. Please try again.");
      setExistingSubscriptions([]);
    } finally {
      setIsLoadingSubs(false);
    }

  }
  // Fetch plans for display purposes
  useEffect(() => {
    if (token) {
      fetchPlans();
      fetchSubs();
    }
  }, [token]);

  const isExpired = (dateString) => {
    if (!dateString || dateString === "-") return false;
    return moment(dateString).isBefore(moment(), 'day');
  };

  const filteredUsers = React.useMemo(() => {
    if (!users) return [];

    const nonMembers = users.filter((user) => !user.isIAM);

    const filtered = nonMembers.filter((user) => {
      if (filterBy === "expired") {
        return isExpired(user.validUntil);
      }
      if (!filterBy && searchQuery) {
        const searchLower = searchQuery.toLowerCase();
        const fullName = `${user.title || ''} ${user.firstName || ''} ${user.lastName || ''}`.toLowerCase();

        return (
          fullName.includes(searchLower) ||
          (user.email && user.email.toLowerCase().includes(searchLower)) ||
          (user.role && user.role.toLowerCase().includes(searchLower))
        );
      }
      if (filterBy && filterValue) {
        if (filterBy === "role") {
          return user.role && user.role.toLowerCase() === filterValue.toLowerCase();
        } else if (filterBy === "planName") {
          if (user.planId) {
            const userPlan = planList.find(plan => plan.id === user.planId);
            return userPlan && userPlan.planName.toLowerCase() === filterValue.toLowerCase();
          }
          return false;
        } else if (filterBy === "status") {
          return user.status && user.status.toLowerCase() === filterValue.toLowerCase();
        }
      }

      return true;
    });


    return filtered.sort((a, b) => {
      const dateA = new Date(a.createdDate || 0);
      const dateB = new Date(b.createdDate || 0);
      return dateB - dateA;
    });
  }, [users, filterBy, filterValue, searchQuery, planList]);

  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;

  const currentUsers = React.useMemo(() => {
    return filteredUsers.slice(indexOfFirstUser, indexOfLastUser);
  }, [filteredUsers, indexOfFirstUser, indexOfLastUser]);

  const totalPages = React.useMemo(() => {
    return Math.ceil(filteredUsers.length / rowsPerPage);
  }, [filteredUsers.length, rowsPerPage]);

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const getRoleChip = (user) => {
    if (user.role.toUpperCase() === "ADMIN") {
      return <span className="role-chip admin-chip">Admin</span>;
    } else if (user.role.toUpperCase() === "SUPER-ADMIN") {
      return <span className="role-chip super-admin-chip">Super Admin</span>;
    } else if (user.role.toUpperCase() === "FRANCHISE-ADMIN") {
      return (
        <span className="role-chip franch-admin-chip">Franchise Admin</span>
      );
    } else if (user.role.toUpperCase() === "MULTIVENDOR-ADMIN") {
      return (
        <span className="role-chip multvendor-admin-chip">MultiVendor Admin</span>
      );
    }
    else if (user.role.toUpperCase() === "RESELLER") {
      return (
        <span className="role-chip reseller-chip">Reseller</span>
      );
    }
    else {
      return <span className="role-chip member-chip">Member</span>;
    }
  };


  const getPlanName = (planId) => {
    console.log(planId);
    if (!planId || !planList.length) {
      return 'No Plan';
    }
    const pl = planList.find(p => p.id === planId);
    if (pl) {
      return pl.planName;
    }

  };

  // Helper function to get plan name from plan ID
  // Helper function to get plan name from plan ID
  const getPlanNameById = (planId) => {
    console.log(planId);
    if (!planId || !planList.length) {
      return <span className="plan-chip plan-no-plan">
        No Plan
      </span>;
    }

    console.log(existingSubscriptions);
    // Find the subscription with matching _id
    const sub = existingSubscriptions.find(s => s._id === planId);
    if (!sub) {
      return <span className="plan-chip plan-unknown">
        Unknown Plan
      </span>;
    }

    // Find the associated plan and attach it
    const pl = planList.find(p => p.id === sub.planId);
    if (pl) {
      return <span className={`plan-chip`}>{`${pl.planName}, ${sub.frequency}, ${sub.frequencyPrice}`}</span>;
    }

  };

  const handleModuleChange = (e) => {
    const { name, checked } = e.target;


    if (name === "digitalSignage" && !checked) {

      setModules((prev) => ({
        ...prev,
        digitalSignage: { ...prev.digitalSignage, enabled: false },
        screens: { ...prev.screens, enabled: false },
        playlist: { ...prev.playlist, enabled: false },
        templates: { ...prev.templates, enabled: false },
        schedules: { ...prev.schedules, enabled: false },
        basicReports: { ...prev.basicReports, enabled: false },
        media: { ...prev.media, enabled: false },
      }));
    } else if (name === "restaurantSolution" && !checked) {

      setModules((prev) => ({
        ...prev,
        restaurantSolution: { ...prev.restaurantSolution, enabled: false },
        pos: { ...prev.pos, enabled: false },
        inventoryManagement: { ...prev.inventoryManagement, enabled: false },
        selfOrderKiosk: { ...prev.selfOrderKiosk, enabled: false },
        selfOrderQR: { ...prev.selfOrderQR, enabled: false },
        ttoApp: { ...prev.ttoApp, enabled: false },
        ttoQR: { ...prev.ttoQR, enabled: false },
        advanceReports: { ...prev.advanceReports, enabled: false },
        members: { ...prev.members, enabled: false },
        customers: { ...prev.customers, enabled: false },
        multikitchen: { ...prev.multikitchen, enabled: false },
      }));
    } else {

      setModules((prev) => ({
        ...prev,
        [name]: {
          ...prev[name],
          enabled: checked,
        },
      }));
    }
  };

  const handleCountChange = (name, e) => {
    let value = e.target.value;

    if (value !== "" && parseInt(value, 10) < 1) {
      value = "1";
    }

    setModules((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        count: value,
      },
    }));
  };

  const handleStorageChange = (name, value, unit) => {
    setModules((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        storage: value,
        storageUnit: unit || prev[name].storageUnit || "MB",
      },
    }));
  };

  const openPlanModal = async () => {
    setShowPlanModal(true);
    setIsLoadingPlans(true);
    setShowAddPlanForm(false);

    try {
      const response = await axios.get(
        `${config.AUTH_API_SERVER}/plan`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log("Fetched plans:", response.data);
      setPlanList(response.data || []);
    } catch (error) {
      console.error("Error fetching plans:", error);
      toast.error("Failed to load plans. Please try again.");
      setPlanList([]);
    } finally {
      setIsLoadingPlans(false);
    }
  };

  const closePlanModal = () => {
    setShowPlanModal(false);
    setShowAddPlanForm(false);
    setIsEditMode(false);
    setEditingPlan(null);
    setPlanName("");

    setModules({
      digitalSignage: { enabled: false },
      screens: { enabled: false, count: "1" },
      playlist: { enabled: false, count: "1" },
      templates: { enabled: false, count: "1" },
      schedules: { enabled: false, count: "1" },
      basicReports: { enabled: false },
      advanceReports: { enabled: false },
      media: { enabled: false, storage: "", storageUnit: "MB" },
      restaurantSolution: { enabled: false },
      pos: { enabled: false },
      inventoryManagement: { enabled: false },
      selfOrderKiosk: { enabled: false },
      selfOrderQR: { enabled: false },
      ttoApp: { enabled: false },
      ttoQR: { enabled: false },
      advanceReports: { enabled: false },
      members: { enabled: false },
      customers: { enabled: false },
      multikitchen: { enabled: false }
    });
  };

  const [planNameError, setPlanNameError] = useState("");

  const validatePlanForm = () => {
    if (!planName.trim()) {
      setPlanNameError("Please enter a plan name");
      return false;
    }

    const hasEnabledModule = Object.values(modules).some(
      (module) => module.enabled === true
    );

    if (!hasEnabledModule) {
      toast.error("Please select at least one module");
      return false;
    }

    if (modules.media.enabled) {
      if (!modules.media.storage || modules.media.storage.trim() === "") {
        toast.error("Please enter a storage size for Media");
        return false;
      }

      const storageValue = parseFloat(modules.media.storage);
      if (isNaN(storageValue) || storageValue <= 0) {
        toast.error("Please enter a valid storage size greater than 0");
        return false;
      }
    }

    return true;
  };

  const handlePlanSave = async () => {
    setPlanNameError("");

    if (!validatePlanForm()) {
      return;
    }
    const payload = {
      planName: planName,
      services: JSON.stringify(modules),
      userId: userData.id,
    };

    console.log(payload);

    try {
      let response;

      if (isEditMode && editingPlan) {
        // Update existing plan
        response = await axios.put(
          `${config.AUTH_API_SERVER}/plan/${editingPlan.id}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Plan updated successfully!");
        fetchPlans();
        fetchSubs();

      } else {
        // Create new plan
        response = await axios.post(
          `${config.AUTH_API_SERVER}/plan`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        toast.success("Plan saved successfully!");
        fetchPlans();
        fetchSubs();

      }

      console.log("Plan operation successful:", response.data);

      // Reset form
      setPlanName("");
      setModules({
        digitalSignage: { enabled: false },
        screens: { enabled: false, count: "1" },
        playlist: { enabled: false, count: "1" },
        templates: { enabled: false, count: "1" },
        schedules: { enabled: false, count: "1" },
        basicReports: { enabled: false },
        advanceReports: { enabled: false },
        media: { enabled: false, storage: "", storageUnit: "MB" },
        restaurantSolution: { enabled: false },
        pos: { enabled: false },
        inventoryManagement: { enabled: false },
        selfOrderKiosk: { enabled: false },
        selfOrderQR: { enabled: false },
        ttoApp: { enabled: false },
        ttoQR: { enabled: false },
        advanceReports: { enabled: false },
        members: { enabled: false },
        customers: { enabled: false },
        multikitchen: { enabled: false }
      });
      setIsEditMode(false);
      setEditingPlan(null);
      setShowAddPlanForm(false);
    } catch (error) {
      console.error(
        "Error saving plan:",
        (error.response && error.response.data) || error.message
      );
      toast.error(
        `Failed to ${isEditMode ? "update" : "save"} plan: ` +
        (error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "Please try again later.")
      );
    }
  };

  // New function to delete a plan
  const deletePlan = async (planId) => {
    setDeletingPlanId(planId);

    try {
      await axios.delete(`${config.AUTH_API_SERVER}/plan/${planId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setPlanList((prevPlans) =>
        prevPlans.filter((plan) => plan.id !== planId)
      );
      toast.success("Plan deleted successfully!");
    } catch (error) {
      console.error("Error deleting plan:", error);
      toast.error("Failed to delete plan. Please try again.");
    } finally {
      setDeletingPlanId(null);
      setShowPlanDeleteDialog(false);
      setPlanToDelete(null);
    }
  };

  const handleDeletePlan = (plan) => {
    setPlanToDelete(plan);
    setShowPlanDeleteDialog(true);
  };

  // Function to handle editing a plan
  const handleEditPlan = (plan) => {
    setIsEditMode(true);
    setEditingPlan(plan);
    setPlanName(plan.planName);

    // Parse and load the existing services/modules
    try {
      const services =
        typeof plan.services === "string"
          ? JSON.parse(plan.services)
          : plan.services;
      setModules(
        services || {
          digitalSignage: { enabled: false },
          screens: { enabled: false, count: "1" },
          playlist: { enabled: false, count: "1" },
          templates: { enabled: false, count: "1" },
          schedules: { enabled: false, count: "1" },
          basicReports: { enabled: false },
          advanceReports: { enabled: false },
          media: { enabled: false, storage: "", storageUnit: "MB" },
          restaurantSolution: { enabled: false },
          pos: { enabled: false },
          inventoryManagement: { enabled: false },
          selfOrderKiosk: { enabled: false },
          selfOrderQR: { enabled: false },
          ttoApp: { enabled: false },
          ttoQR: { enabled: false },
          advanceReports: { enabled: false },
          members: { enabled: false },
          customers: { enabled: false },
          multikitchen: { enabled: false }
        }
      );
    } catch (error) {
      console.error("Error parsing plan services:", error);
      toast.error("Error loading plan data");
    }

    setShowAddPlanForm(true);
  };

  // Open/Close Subscription Modal
  const openSubModal = async () => {
    setShowSubModal(true);
    //setIsLoadingSubs(true);
    setShowAddSubForm(false); // Hide add subscription form initially
  };

  const closeSubModal = () => {
    setShowSubModal(false);
    setShowAddSubForm(false); // Reset form visibility when closing modal
    setIsEditModeSub(false); // Reset edit mode
    setEditingSub({}); // Clear editing subscription
    // Reset subscriptions when closing
    setSubscriptions([
      { id: 1, planId: "", durations: [{ id: 1, duration: "", price: "" }] },
    ]);
  };

  // Get abbreviated duration code (supporting both formats)
  const getDurationCode = (durationValue) => {
    switch (durationValue) {
      case "monthly":
        return "monthly";
      case "quarterly":
        return "quarterly";
      case "half-yearly":
        return "half-yearly";
      case "yearly":
        return "yearly";
      default:
        return durationValue;
    }
  };

  // Handle subscription save
  const handleSubscriptionSave = async () => {
    try {
      if (editingSub._id || editingSub.id) {
        const subscriptionId = editingSub._id || editingSub.id;
        await subscriptionAPI.updateSubscription(subscriptionId, editingSub);
        console.log("Subscription updated:", subscriptionId);
        toast.success("Subscription updated successfully!");
      } else {
        let newSub = JSON.parse(JSON.stringify(editingSub));
        newSub.frequency = newSub.frequency ? newSub.frequency : 'monthly';
        newSub.frequencyPrice = newSub.frequencyPrice ? newSub.frequencyPrice : '0';
        newSub.currency = newSub.currency ? newSub.currency : 'USD';
        const result = await subscriptionAPI.createSubscription({ ...newSub, userId: userData.id });
        toast.success("Subscription plans created successfully!");
      }

      // Close modal and reset state
      setShowSubModal(false);
      setIsEditModeSub(false);
      setEditingSub({});
    } catch (error) {
      console.error("Error saving subscriptions:", error);
      const errorMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        "Failed to save subscription plans. Please try again.";
      toast.error(errorMessage);
    }
  };

  // Function to handle editing a subscription
  const handleEditSubscription = (sub) => {
    setIsEditModeSub(true);
    setEditingSub(sub);
    setShowAddSubForm(true);
  };

  // This function is no longer needed since we're using the exact duration format
  // Keeping an empty function for compatibility in case it's referenced elsewhere
  const convertDurationCodeToValue = (code) => {
    return code; // Just return the code as is, no conversion needed
  };

  // Function to handle deleting a subscription
  const handleDeleteSubscription = (sub) => {
    setSubToDelete(sub);
    setShowSubDeleteDialog(true);
  };

  // Function to actually delete the subscription
  const deleteSubscription = async (subscriptionId) => {
    setDeletingSubId(subscriptionId);

    try {
      // Using _id from the subscription object instead of id
      const idToDelete =
        subToDelete && subToDelete._id ? subToDelete._id : subscriptionId;
      await subscriptionAPI.deleteSubscription(idToDelete);

      setExistingSubscriptions((prevSubs) =>
        prevSubs.filter((sub) => (sub._id || sub.id) !== idToDelete)
      );
      toast.success("Subscription deleted successfully!");
    } catch (error) {
      console.error("Error deleting subscription:", error);
      toast.error("Failed to delete subscription. Please try again.");
    } finally {
      setDeletingSubId(null);
      setShowSubDeleteDialog(false);
      setSubToDelete(null);
    }
  };

  // Duration options
  const durationOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "half-yearly", label: "Half Yearly" },
    { value: "yearly", label: "Yearly" },
  ];

  // Currency options for dropdown
  const currencyOptions = [
    { value: "USD", label: "USD ($)", symbol: "$" },
    { value: "EUR", label: "EUR (€)", symbol: "€" },
    { value: "GBP", label: "GBP (£)", symbol: "£" },
    { value: "INR", label: "INR (₹)", symbol: "₹" },
    { value: "JMD", label: "JMD (J$)", symbol: "J$" },
    { value: "JPY", label: "JPY (¥)", symbol: "¥" },
    { value: "CAD", label: "CAD ($)", symbol: "$" },
    { value: "AUD", label: "AUD ($)", symbol: "$" },
    { value: "CHF", label: "CHF (Fr)", symbol: "Fr" },
    { value: "CNY", label: "CNY (¥)", symbol: "¥" },
    { value: "HKD", label: "HKD ($)", symbol: "HK$" },
    { value: "NZD", label: "NZD ($)", symbol: "NZ$" },
    { value: "AED", label: "AED (د.إ)", symbol: "د.إ" },
    { value: "SAR", label: "SAR (SR)", symbol: "SR" },
    { value: "SGD", label: "SGD ($)", symbol: "S$" },
    { value: "QAR", label: "QAR (QR)", symbol: "QR" },
    { value: "KWD", label: "KWD (KD)", symbol: "KD" },
    { value: "BHD", label: "BHD (BD)", symbol: "BD" },
    { value: "OMR", label: "OMR (RO)", symbol: "RO" },
    { value: "MYR", label: "MYR (RM)", symbol: "RM" },
    { value: "IDR", label: "IDR (Rp)", symbol: "Rp" },
    { value: "THB", label: "THB (฿)", symbol: "฿" },
    { value: "VND", label: "VND (₫)", symbol: "₫" },
    { value: "PHP", label: "PHP (₱)", symbol: "₱" },
    { value: "ZAR", label: "ZAR (R)", symbol: "R" },
    { value: "NGN", label: "NGN (₦)", symbol: "₦" },
    { value: "KES", label: "KES (KSh)", symbol: "KSh" },
    { value: "EGP", label: "EGP (E£)", symbol: "E£" },
    { value: "BRL", label: "BRL (R$)", symbol: "R$" },
    { value: "MXN", label: "MXN ($)", symbol: "$" },
    { value: "ARS", label: "ARS ($)", symbol: "$" },
  ];

  return (
    <div>
      {/* Top controls */}
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "20px", padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            gap: "10px",
            marginRight: "auto",
          }}
        >
          <select
            className="form-control"
            value={filterBy}
            onChange={(e) => {
              setFilterBy(e.target.value);
              setFilterValue("");
            }}
            style={{
              width: "150px",
              paddingLeft: "10px",
            }}
          >
            <option value="">Filter By</option>
            <option value="role">Role</option>
            <option value="planName">Plan Name</option>
            <option value="status">Status</option>
            <option value="expired">Plan Expired</option>
          </select>

          {filterBy === "role" && (
            <select
              className="form-control"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              style={{
                width: "150px",
                paddingLeft: "10px",
              }}
            >
              <option value="">All Roles</option>
              <option value="admin">Admin</option>
              <option value="super-admin">Super Admin</option>
              <option value="franchise-admin">Franchise Admin</option>
              <option value="multivendor-admin">MultiVendor Admin</option>
              <option value="member">Member</option>
            </select>
          )}

          {filterBy === "planName" && (
            <select
              className="form-control"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              style={{
                width: "150px",
                paddingLeft: "10px",
              }}
            >
              <option value="">All Plans</option>
              {planList.map(plan => (
                <option key={plan.id} value={plan.planName.toLowerCase()}>
                  {plan.planName}
                </option>
              ))}
            </select>
          )}

          {filterBy === "status" && (
            <select
              className="form-control"
              value={filterValue}
              onChange={(e) => setFilterValue(e.target.value)}
              style={{
                width: "150px",
                paddingLeft: "10px",
              }}
            >
              <option value="">All Status</option>
              <option value="active">Active</option>
              <option value="deactive">Deactive</option>
            </select>
          )}

          {!filterBy && (
            <input
              type="text"
              placeholder="Search"
              className="form-control"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{
                width: "280px",
                paddingLeft: "20px",
              }}
            />
          )}
        </div>
        <button className="btn-sub" onClick={openSubModal}>
          Manage Subscription
        </button>
        <button className="btn-plan" onClick={openPlanModal}>
          Manage Plan
        </button>
        <button 
          className="btn-custom" 
          style={{ float: "right" }}
          onClick={() => setShowAddUserModal(true)}
        >
          Add User
        </button>
      </div>

      {/* Users table */}
      <table className="table table-striped">
        <thead>
          <tr>
            <th style={{ width: "20%" }}>Name</th>
            <th style={{ width: "20%" }}>Email</th>
            <th style={{ width: "15%" }}>Subscription Plan</th>
            <th style={{ width: "15%" }}>Validity</th>
            <th style={{ width: "10%" }}>Status</th>
            <th style={{ width: "15%" }}>Join On</th>
            <th style={{ width: "5%" }}></th>
          </tr>
        </thead>
        <tbody>
          {currentUsers && currentUsers.length > 0 ?
            currentUsers.map((user) => (
              <tr key={user.id}>
                <td>
                  <div style={{ fontWeight: "bold" }}>
                    {user.title} {user.firstName} {user.lastName}
                  </div>
                  <div style={{ fontSize: "0.85em", marginTop: "-2px" }}>
                    {getRoleChip(user)}
                  </div>
                </td>
                <td>{user.email}</td>
                <td>{getPlanNameById(user.planId)}</td>
                <td>
                  {isExpired(user.validUntil) && <span className="expired-dot" title="Plan Expired"></span>}
                  {user.validUntil || "-"}
                </td>
                <td>
                  <span
                    className={`status-chip ${user.status && user.status.toLowerCase() === "active"
                      ? "status-active"
                      : user.status && user.status.toLowerCase() === "paid"
                        ? "status-chip-paid"
                        : user.status && user.status.toLowerCase() === "demo"
                          ? "status-chip-demo"
                          : "status-deactive"
                      }`}
                  >
                    {user.status && user.status.toUpperCase()}
                  </span>
                </td>
                <td style={{ whiteSpace: "nowrap", fontSize: "0.8em" }}>
                  {moment(user.createdDate).format("DD/MMM/YY HH:mm")}
                </td>
                <td style={{ whiteSpace: "nowrap" }}>
                  <Link
                    to={`${path}/view/${user.id}`}
                    className="btn btn-shadow"
                    style={{ fontWeight: "bold" }}
                  >
                    <i class="bi bi-eye" style={{ marginRight: '5px', }}></i>View
                  </Link>
                </td>
              </tr>
            ))
            : (
              <tr>
                <td colSpan="6" className="text-center">
                  <span className="spinner-border spinner-border-lg align-center"></span>
                </td>
              </tr>
            )
          }
        </tbody>
      </table>

      {/* Pagination controls */}
      <div className="pagination-controls">
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <button
            onClick={handlePreviousPage}
            className="btn btn-secondary btn-sm"
            disabled={currentPage === 1}
            style={{ minWidth: "80px" }}
          >
            Previous
          </button>

          <span
            style={{
              marginRight: "10px",
              border: "0.5px solid black",
              padding: "10px",
            }}
          >
            {rowsPerPage}
          </span>

          <button
            onClick={handleNextPage}
            className="btn btn-secondary btn-sm"
            disabled={currentPage === totalPages}
            style={{ minWidth: "80px" }}
          >
            Next
          </button>
        </div>
      </div>

      {/* Plan modal */}

      {/* Plan modal */}
      {showPlanModal && (
        <div
          className="plan-modal-overlay"
          onClick={closePlanModal}
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <div
            className="plan-modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="planModalTitle"
            style={{
              maxWidth: "900px",
              width: "90%",
              padding: "10px",
              borderRadius: "8px",
              maxHeight: "90vh",
              overflow: "auto",
              position: "relative",
              backgroundColor: "#ffffff",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              border: "1px solid #eaeaea",
              animation: "modalFadeIn 0.3s ease-out",
            }}
          >
            {/* Close Button (X) in top-right corner */}
            <div style={{ position: "absolute", top: "15px", right: "15px" }}>
              <button
                onClick={closePlanModal}
                style={{
                  background: "rgba(0,0,0,0.05)",
                  border: "none",
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#64748b",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  transition: "all 0.2s ease",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f44336";
                  e.currentTarget.style.color = "white";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "rgba(0,0,0,0.05)";
                  e.currentTarget.style.color = "#64748b";
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <h2
              id="planModalTitle"
              style={{
                textAlign: "center",
                background: "transparent",
                color: "#333333",
                fontWeight: "600",
                paddingBottom: "20px",
                paddingTop: "10px",
                fontSize: "22px",
                borderBottom: "1px solid #eaeaea"
              }}
            >
              {showAddPlanForm ? "Add New Plan" : "Manage Plans"}
            </h2>

            {/* Add New Plan Button */}
            {!showAddPlanForm && <div style={{ textAlign: "right" }}>
              <button
                onClick={() => setShowAddPlanForm(!showAddPlanForm)}
                style={{
                  padding: "12px 24px",
                  fontSize: "15px",
                  fontWeight: "600",
                  letterSpacing: "0.3px",
                  borderRadius: "8px",
                  background: "transparent",
                  color: "black",
                  border: "1px solid #ddd",
                  display: "inline-flex",
                  alignItems: "center",
                  transition: "all 0.3s ease",
                  minWidth: "180px",
                  justifyContent: "center",
                  cursor: "pointer",
                  marginTop: "10px"
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 15px rgba(0,0,0,0.15)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "none";
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    lineHeight: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {"+"}
                </span>
                {"Add New Plan"}
              </button>
            </div>}

            {/* Display existing plans or Add New Plan form based on showAddPlanForm state */}
            {!showAddPlanForm ? (
              <div
                style={{
                  padding: "10px",
                }}
              >
                {isLoadingPlans ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <span
                      className="spinner-border"
                      style={{
                        width: "48px",
                        height: "48px",
                        color: "#3b82f6",
                      }}
                    ></span>
                    <p
                      style={{
                        fontSize: "18px",
                        color: "#64748b",
                        fontWeight: "500",
                        marginTop: "10px",
                      }}
                    >
                      Loading plans...
                    </p>
                  </div>
                ) : planList.length > 0 ? (
                  <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                    <table
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        margin: 0,
                        background: "#fff"
                      }}
                    >

                      <tbody>
                        {planList.map((plan) => (
                          <tr
                            key={plan.id}
                            style={{
                              borderBottom: '1px solid #ebeaea'
                            }}

                          >
                            <td>
                              {plan.planName}
                            </td>
                            <td
                              style={{
                                padding: "16px 20px",
                                textAlign: "right",
                                borderTopRightRadius: "12px",
                                borderBottomRightRadius: "12px",
                                border: "none",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  gap: "10px",
                                  justifyContent: "flex-end",
                                }}
                              >

                                <i style={{ color: "red", cursor: "pointer", marginRight: "20px" }} class="bi bi-trash" onClick={() => handleDeletePlan(plan)}></i>

                                <i style={{ cursor: "pointer", marginRight: "20px" }} class="bi bi-pencil-fill" onClick={() => handleEditPlan(plan)}
                                ></i>


                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: "#64748b",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",

                    }}
                  >
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "32px",
                      }}
                    >
                      📋
                    </div>
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#64748b",
                        marginBottom: "5px",
                      }}
                    >
                      No plans found
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#94a3b8",
                      }}
                    >
                      Click "Add New Plan" to create your first plan
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <>
                <div
                  style={{
                    padding: "10px",
                    marginBottom: "10px",
                  }}
                >
                  <label
                    htmlFor="planName"
                    style={{
                      fontWeight: "600",
                      marginBottom: "12px",
                      display: "block",
                      fontSize: "16px",
                      color: "#0369a1",
                    }}
                  >
                    Plan Name
                  </label>
                  <div style={{ position: "relative" }}>
                    <input
                      id="planName"
                      type="text"
                      placeholder="Enter Plan Name"
                      value={planName}
                      onChange={(e) => {
                        setPlanName(e.target.value);
                        if (e.target.value.trim()) {
                          setPlanNameError("");
                        }
                      }}
                      style={{
                        width: "300px",
                        padding: "14px",
                        fontSize: "18px",
                        borderRadius: "8px",
                        border: `1px solid "#93c5fd"
                        }`,
                        color: "#1e293b",
                        backgroundColor: "#fff",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                        fontWeight: "500"

                      }}
                    />
                  </div>
                  {planNameError && (
                    <div
                      style={{
                        color: "#ef4444",
                        fontSize: "14px",
                        marginTop: "8px",
                        marginLeft: "2px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <span>⚠️</span> {planNameError}
                    </div>
                  )}
                </div>

                <h3
                  style={{
                    marginBottom: "10px",
                    textAlign: "center",
                    color: "#0f172a",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "12px",
                    fontWeight: "700",
                    fontSize: "22px",
                  }}
                >
                  Select Enabled Modules
                </h3>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: "30px",
                    marginBottom: "30px",
                    flexWrap: "wrap",
                  }}
                >
                  {/* Digital Signage Section */}
                  <div
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "8px",
                      minWidth: "280px",
                    }}
                  >

                    <ModuleCheckbox
                      name="digitalSignage"
                      label="Digital Signage"
                      checked={modules.digitalSignage.enabled}
                      onChange={handleModuleChange}
                      isMainModule={true}
                    />

                    <div
                      style={{
                        marginLeft: "25px",
                        marginTop: "20px",
                        paddingTop: "20px",
                        borderTop: `1px dashed ${modules.digitalSignage.enabled ? "#a7f3d0" : "#e2e8f0"
                          }`,
                        opacity: modules.digitalSignage.enabled ? 1 : 0.5,
                        transition: "all 0.3s ease",
                      }}
                    >
                      <ModuleCheckbox
                        name="screens"
                        label="Screens"
                        checked={modules.screens.enabled}
                        onChange={handleModuleChange}
                        showCountButton
                        countValue={modules.screens.count}
                        onCountChange={(e) => handleCountChange("screens", e)}
                        disabled={!modules.digitalSignage.enabled}
                      />
                      <ModuleCheckbox
                        name="playlist"
                        label="Playlist"
                        checked={modules.playlist.enabled}
                        onChange={handleModuleChange}
                        showCountButton
                        countValue={modules.playlist.count}
                        onCountChange={(e) => handleCountChange("playlist", e)}
                        disabled={!modules.digitalSignage.enabled}
                      />
                      <ModuleCheckbox
                        name="templates"
                        label="Templates"
                        checked={modules.templates.enabled}
                        onChange={handleModuleChange}
                        showCountButton
                        countValue={modules.templates.count}
                        onCountChange={(e) => handleCountChange("templates", e)}
                        disabled={!modules.digitalSignage.enabled}
                      />
                      <ModuleCheckbox
                        name="schedules"
                        label="Schedules"
                        checked={modules.schedules.enabled}
                        onChange={handleModuleChange}
                        showCountButton
                        countValue={modules.schedules.count}
                        onCountChange={(e) => handleCountChange("schedules", e)}
                        disabled={!modules.digitalSignage.enabled}
                      />
                      <ModuleCheckbox
                        name="basicReports"
                        label="Basic Reports"
                        checked={modules.basicReports.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.digitalSignage.enabled}
                      />
                      <ModuleCheckbox
                        name="media"
                        label="Media"
                        checked={modules.media.enabled}
                        onChange={handleModuleChange}
                        showStorageSize
                        storageValue={modules.media.storage}
                        onStorageChange={handleStorageChange}
                        disabled={!modules.digitalSignage.enabled}
                      />
                    </div>
                  </div>

                  {/* Restaurant Solution Section */}
                  <div
                    style={{
                      flex: 1,
                      padding: "10px",
                      borderRadius: "8px",
                      borderLeft: `1px solid #ccc`,
                      minWidth: "280px",
                    }}
                  >

                    <ModuleCheckbox
                      name="restaurantSolution"
                      label="Restaurant Solution"
                      checked={modules.restaurantSolution.enabled}
                      onChange={handleModuleChange}
                      isMainModule={true}
                    />

                    <div
                      style={{
                        marginLeft: "25px",
                        marginTop: "20px",
                        paddingTop: "20px",
                        borderTop: `1px dashed ${modules.restaurantSolution.enabled
                          ? "#bfdbfe"
                          : "#e2e8f0"
                          }`,
                        opacity: modules.restaurantSolution.enabled ? 1 : 0.5,
                        transition: "all 0.3s ease",
                      }}
                    >
                      <ModuleCheckbox
                        name="pos"
                        label="PoS"
                        checked={modules.pos.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />
                      <ModuleCheckbox
                        name="inventoryManagement"
                        label="Inventory Management"
                        checked={modules.inventoryManagement.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />
                      <ModuleCheckbox
                        name="selfOrderKiosk"
                        label="Self Order Kiosk"
                        checked={modules.selfOrderKiosk.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />
                      <ModuleCheckbox
                        name="selfOrderQR"
                        label="Self Order QR"
                        checked={modules.selfOrderQR.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />
                      <ModuleCheckbox
                        name="ttoApp"
                        label="TTO App"
                        checked={modules.ttoApp.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />
                      <ModuleCheckbox
                        name="ttoQR"
                        label="TTO QR"
                        checked={modules.ttoQR.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />

                      <ModuleCheckbox
                        name="customers"
                        label="Customers"
                        checked={modules.customers && modules.customers.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />

                      <ModuleCheckbox
                        name="members"
                        label="Memebers"
                        checked={modules.members && modules.members.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />

                      <ModuleCheckbox
                        name="multikitchen"
                        label="Multi-Kitchen"
                        checked={modules.multikitchen && modules.multikitchen.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />

                      <ModuleCheckbox
                        name="advanceReports"
                        label="Advance-Reports"
                        checked={modules.advanceReports && modules.advanceReports.enabled}
                        onChange={handleModuleChange}
                        disabled={!modules.restaurantSolution.enabled}
                      />

                    </div>
                  </div>
                </div>
              </>
            )}

            {/* Only show Save Plan button when the form is active */}
            {showAddPlanForm && (
              <div
                style={{
                  marginTop: "30px",
                  display: "flex",
                  justifyContent: "flex-end",
                  borderTop: "1px solid #e2e8f0",
                  paddingTop: "20px",
                  gap: "15px",
                }}
              >
                <button
                  onClick={() => setShowAddPlanForm(false)}
                  style={{
                    padding: "10px 25px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    backgroundColor: "transparent",
                    color: "red",
                    cursor: "pointer",
                    border: "none"
                  }}

                >
                  Cancel
                </button>
                <button
                  onClick={handlePlanSave}
                  style={{
                    padding: "10px 25px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    backgroundColor: "#000",
                    color: "#fff",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}

                >
                  Save Plan
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Subscription modal */}
      {showSubModal && (
        <div
          className="plan-modal-overlay"
          onClick={closeSubModal}
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <div
            className="plan-modal-content"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="subModalTitle"
            style={{
              maxWidth: "900px",
              width: "90%",
              padding: "25px",
              borderRadius: "8px",
              maxHeight: "90vh",
              overflow: "auto",
              position: "relative",
              backgroundColor: "#ffffff",
              border: "1px solid #eaeaea",

            }}
          >
            {/* Close Button (X) in top-right corner */}
            <div style={{ position: "absolute", top: "30px", right: "15px" }}>
              <button
                onClick={closeSubModal}
                style={{
                  border: "none",
                  fontSize: "22px",
                  cursor: "pointer",
                  color: "#64748b",
                  width: "36px",
                  height: "36px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = "#f44336";
                  e.currentTarget.style.color = "white";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = "rgba(0,0,0,0.05)";
                  e.currentTarget.style.color = "#64748b";
                }}
                aria-label="Close"
              >
                ×
              </button>
            </div>

            <h2
              id="subModalTitle"
              style={{
                textAlign: "center",
                background: "transparent",
                color: "#333333",
                fontWeight: "600",
                paddingBottom: "20px",
                paddingTop: "10px",
                fontSize: "22px",
                borderBottom: "1px solid #eaeaea"
              }}
            >
              {showAddSubForm ? "Create Subscription" : "Manage Subscriptions"}
            </h2>

            {/* Add New Subscription Button */}
            {!showAddSubForm && <div style={{ textAlign: "right", marginBottom: "10px" }}>
              <button
                onClick={() => (setEditingSub({}), setShowAddSubForm(!showAddSubForm))}
                style={{
                  padding: "12px 20px",
                  fontSize: "15px",
                  fontWeight: "600",
                  letterSpacing: "0.3px",
                  borderRadius: "8px",
                  background: "transparent",
                  color: "black",
                  border: "1px solid #ccc",
                  display: "inline-flex",
                  alignItems: "center",
                  marginTop: "10px",
                  minWidth: "220px",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 15px rgba(0,0,0,0.15)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow =
                    "none";
                }}
              >
                <span
                  style={{
                    fontSize: "20px",
                    lineHeight: "20px",
                    fontWeight: "bold",
                  }}
                >
                  {"+"}
                </span>
                Add New Subscription
              </button>
            </div>}

            {/* Display existing subscriptions or Add New Subscription form based on showAddSubForm state */}
            {!showAddSubForm ? (
              <div
                style={{
                  padding: "10px",
                }}
              >
                {isLoadingSubs ? (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",

                    }}
                  >
                    <span
                      className="spinner-border"
                      style={{
                        width: "48px",
                        height: "48px",
                        color: "#10b981",
                      }}
                    ></span>
                    <p
                      style={{
                        fontSize: "18px",
                        color: "#64748b",
                        fontWeight: "500",
                        marginTop: "10px",
                      }}
                    >
                      Loading subscriptions...
                    </p>
                  </div>
                ) : existingSubscriptions.length > 0 ? (
                  <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                    {/* Group subscriptions by planId */}
                    {Object.entries(
                      existingSubscriptions.reduce((acc, sub) => {
                        const planName = getPlanName(sub.planId);
                        if (!acc[planName]) {
                          acc[planName] = [];
                        }
                        acc[planName].push(sub);
                        return acc;
                      }, {})
                    ).map(([planName, subs]) => (
                      <div
                        key={planName}
                        style={{
                          marginBottom: "30px",
                          overflow: "hidden",
                          border: "1px solid #e2e8f0",
                        }}
                      >
                        <div
                          style={{
                            backgroundColor: "#f8f9fa",
                            padding: "12px 20px",
                            color: "#333",
                            fontWeight: "600",
                            fontSize: "18px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            borderBottom: "1px solid #e2e8f0"
                          }}
                        >

                          {planName}
                        </div>

                        <div style={{ padding: "0 10px" }}>
                          <table
                            style={{
                              width: "100%",
                              borderCollapse: "separate",
                              borderSpacing: "0 8px",
                            }}
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{
                                    padding: "10px",
                                    color: "#475569",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textAlign: "left",
                                  }}
                                >
                                  Duration
                                </th>
                                <th
                                  style={{
                                    padding: "10px",
                                    color: "#475569",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textAlign: "center",
                                  }}
                                >
                                  Price
                                </th>
                                <th
                                  style={{
                                    padding: "10px",
                                    color: "#475569",
                                    fontWeight: "600",
                                    fontSize: "14px",
                                    textAlign: "right",
                                  }}
                                >
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {subs.map((sub) => (
                                <tr
                                  key={sub._id || sub.id}
                                  style={{
                                    backgroundColor: "white",
                                    boxShadow: "0 2px 4px rgba(0,0,0,0.03)",
                                    borderRadius: "8px",
                                    transition: "all 0.2s ease",
                                  }}
                                  onMouseOver={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "#f8fafc";
                                    e.currentTarget.style.boxShadow =
                                      "0 4px 6px rgba(0,0,0,0.06)";
                                  }}
                                  onMouseOut={(e) => {
                                    e.currentTarget.style.backgroundColor =
                                      "white";
                                    e.currentTarget.style.boxShadow =
                                      "0 2px 4px rgba(0,0,0,0.03)";
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "12px 16px",
                                      borderTopLeftRadius: "8px",
                                      borderBottomLeftRadius: "8px",
                                    }}
                                  >
                                    <div className={"role-chip " + sub.frequency}>
                                      {sub.frequency.toUpperCase()}
                                    </div>
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px 16px",
                                      fontSize: "16px",
                                      fontWeight: "600",
                                      color: "#334155",
                                      textAlign: "center",
                                    }}
                                  >
                                    <span
                                      style={{
                                        backgroundColor: "#f1f5f9",
                                        padding: "6px 12px",
                                        borderRadius: "6px",
                                        color: "#0f172a",
                                      }}
                                    >
                                      ₹{sub.frequencyPrice}
                                    </span>
                                  </td>
                                  <td
                                    style={{
                                      padding: "12px 16px",
                                      borderTopRightRadius: "8px",
                                      borderBottomRightRadius: "8px",
                                      textAlign: "right",
                                    }}
                                  >
                                    <div
                                      className={`role-actions`}
                                      style={{ justifyContent: "flex-end" }}
                                    >
                                      <i style={{ color: "red", cursor: "pointer", marginRight: "20px" }} class="bi bi-trash" onClick={() =>
                                        handleDeleteSubscription(sub)}></i>

                                      <i style={{ cursor: "pointer", marginRight: "20px" }} class="bi bi-pencil-fill" onClick={() =>
                                        handleEditSubscription(sub)}></i>

                                    </div>

                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      padding: "40px",
                      color: "#64748b",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "15px",
                    }}
                  >
                    <div
                      style={{
                        width: "80px",
                        height: "80px",
                        borderRadius: "50%",
                        backgroundColor: "#f1f5f9",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "32px",
                      }}
                    >
                      💰
                    </div>
                    <p
                      style={{
                        fontSize: "18px",
                        fontWeight: "500",
                        color: "#64748b",
                        marginBottom: "5px",
                      }}
                    >
                      No subscriptions found
                    </p>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#94a3b8",
                      }}
                    >
                      Click "Add New Subscription" to create your first
                      subscription
                    </p>
                  </div>
                )}
              </div>
            ) : (
              <div>
                <div
                  key={editingSub._id || ""}
                  style={{
                    marginBottom: "10px",
                    backgroundColor: "#ffffff",
                    borderRadius: "8px",
                    border: "1px solid #e9ecef",
                    padding: "10px",
                    overflow: "hidden",
                  }}
                >
                  {/* Plan and Currency selection section */}
                  <div
                    style={{
                      color: "#333",
                      padding: "15px",
                      fontWeight: "600",
                      fontSize: "16px",
                    }}
                  >
                    <div style={{ display: "flex", gap: "15px" }}>
                      {/* Plan Selection - 50% width */}
                      <div style={{ flex: "1" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: "600",
                            color: "#333",
                            fontSize: "16px",
                          }}
                        >
                          Select Plan
                        </label>
                        <select
                          className="form-control"
                          value={editingSub.planId || ""}
                          onChange={(e) => setEditingSub({ ...editingSub, planId: e.target.value })}
                          style={{
                            width: "100%",
                            padding: "8px 15px",
                            borderRadius: "8px",

                            fontSize: "16px",
                            backgroundColor: "#ffffff",
                            color: "#2c3e50",
                            fontWeight: "500",
                          }}
                        >
                          <option value="">Choose a plan...</option>
                          {planList.map((plan) => (
                            <option key={plan.id} value={plan.id}>
                              {plan.planName}
                            </option>
                          ))}
                        </select>
                      </div>

                      {/* Currency Selection - 50% width */}
                      <div style={{ flex: "1" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: "300",
                            color: "#333",
                            fontSize: "14px",
                          }}
                        >
                          Select Currency
                        </label>
                        <select
                          className="form-control"
                          value={editingSub.currency || "USD"}
                          onChange={(e) => setEditingSub({ ...editingSub, currency: e.target.value })}
                          style={{
                            width: "100%",
                            padding: "8px 15px",
                            borderRadius: "8px",
                            border: "1px solid #ccc",
                            fontSize: "16px",
                            backgroundColor: "#fff",
                            color: "#2c3e50",
                            fontWeight: "500",
                          }}
                        >
                          {currencyOptions.map(option => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* Durations section */}
                  <div >
                    <div

                      style={{
                        display: "flex",
                        alignItems: "center",
                        padding: "15px",
                        borderRadius: "8px",

                      }}
                    >
                      {/* Duration selection */}
                      <div style={{ flex: "1", marginRight: "10px" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            color: "#000",
                          }}
                        >
                          Duration
                        </label>
                        <div
                          style={{
                            color: "#333",
                            padding: "12px 15px",

                          }}
                        >
                          <select
                            value={editingSub.frequency || "monthly"}
                            onChange={(e) =>
                              setEditingSub({ ...editingSub, frequency: e.target.value })
                            }
                            style={{
                              color: "#2c3e50",
                              border: "1px solid #ccc",
                              width: "100%",
                              padding: "10px 15px",
                              borderRadius: "8px"
                            }}
                          >
                            <option value="" style={{ color: "#2c3e50" }}>
                              Select Duration
                            </option>
                            {durationOptions.map((opt) => (
                              <option
                                key={opt.value}
                                value={opt.value}
                                style={{ color: "#2c3e50" }}
                              >
                                {opt.label}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Price input */}
                      <div style={{ flex: "1" }}>
                        <label
                          style={{
                            display: "block",
                            marginBottom: "8px",
                            fontWeight: "500",
                            color: "#2c3e50",
                            fontSize: "14px",
                          }}
                        >
                          Price
                        </label>
                        <div
                          style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              position: "absolute",
                              left: "12px",
                              fontSize: "16px",
                              fontWeight: "600",
                              color: "#2c3e50",
                              zIndex: 1,
                            }}
                          >
                            {editingSub.currency || "USD"}
                          </span>
                          <input
                            type="number"
                            className="form-control"
                            placeholder="0"
                            value={editingSub.frequencyPrice || 0}
                            onChange={(e) => setEditingSub({ ...editingSub, frequencyPrice: e.target.value.toString() })}
                            min="0"
                            step="1"
                            style={{
                              width: "100%",
                              padding: "12px 15px 12px 30px",
                              borderRadius: "8px",
                              border: "1px solid #cbd5e0",
                              fontSize: "14px",
                              textAlign: "center",
                              minHeight: "45px",
                            }}
                          />
                        </div>
                      </div>

                    </div>

                  </div>
                </div>

              </div>
            )}

            {/* Action Buttons */}
            {showAddSubForm && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "10px",
                  borderTop: "1px solid #e9ecef",
                  paddingTop: "20px",
                }}
              >
                <button
                  onClick={() => setShowAddSubForm(false)}
                  style={{
                    padding: "10px 25px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    backgroundColor: "transparent",
                    color: "red",
                    border: "none",
                    cursor: "pointer",

                  }}
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubscriptionSave}
                  style={{
                    padding: "10px 30px",
                    fontSize: "16px",
                    fontWeight: "500",
                    borderRadius: "6px",
                    backgroundColor: "#000",
                    color: "#fff",
                    border: "1px solid #ddd",
                    cursor: "pointer",
                    transition: "all 0.2s ease",
                  }}

                >
                  Save Subscriptions
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Plan delete confirmation dialog */}
      {showPlanDeleteDialog && planToDelete && (
        <div className="dialog-overlay" style={{ zIndex: 99999 }}>
          <div className="dialog">
            <h3>Warning!!</h3>
            <p>
              Are you sure you want to delete plan{" "}
              <strong>"{planToDelete.planName}"</strong>?
            </p>
            <div>
              <button
                className="confirm"
                onClick={() => deletePlan(planToDelete.id)}
              >
                {deletingPlanId === planToDelete.id ? (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                ) : null}
                Yes
              </button>
              <button
                className="cancel"
                onClick={() => {
                  setShowPlanDeleteDialog(false);
                  setPlanToDelete(null);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Subscription delete confirmation dialog */}
      {showSubDeleteDialog && subToDelete && (
        <div className="dialog-overlay" style={{ zIndex: 99999 }}>
          <div className="dialog">
            <h3>Warning!!</h3>
            <p>Are you sure you want to delete this subscription?</p>
            <div>
              <button
                className="confirm"
                onClick={() =>
                  deleteSubscription(subToDelete._id || subToDelete.id)
                }
              >
                {deletingSubId === (subToDelete._id || subToDelete.id) ? (
                  <span className="spinner-border spinner-border-sm mr-1"></span>
                ) : null}
                Yes
              </button>
              <button
                className="cancel"
                onClick={() => {
                  setShowSubDeleteDialog(false);
                  setSubToDelete(null);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* User creation modal */}
      {showAddUserModal && (
        <div
          className="plan-modal-overlay"
          onClick={() => setShowAddUserModal(false)}
          style={{
            backgroundColor: "rgba(0,0,0,0.5)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <div
            className="plan-modal-content"
            onClick={(e) => e.stopPropagation()}
            style={{
              maxWidth: "800px",
              width: "90%",
              padding: "20px",
              borderRadius: "12px",
              maxHeight: "90vh",
              overflow: "auto",
              position: "relative",
              backgroundColor: "#ffffff",
              boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #f1f5f9', paddingBottom: '15px' }}>
              <h2 style={{ margin: 0, color: '#1e293b', fontSize: '24px', fontWeight: '700' }}>Create New User</h2>
              <button 
                onClick={() => setShowAddUserModal(false)}
                style={{ background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#64748b' }}
              >
                &times;
              </button>
            </div>
            <AddUserPopup 
              onClose={() => setShowAddUserModal(false)} 
              onSuccess={() => {
                setShowAddUserModal(false);
                fetchUsers();
              }}
              planList={planList}
            />
          </div>
        </div>
      )}
    </div>
  );
}

function ModuleCheckbox({
  name,
  label,
  checked,
  onChange,
  showCountButton,
  showStorageSize,
  countValue,
  storageValue,
  onCountChange,
  onStorageChange,
  disabled = false,
  isMainModule = false,
}) {
  const [storageUnit, setStorageUnit] = useState("MB");

  const handleStorageUnitChange = (e) => {
    const newUnit = e.target.value;
    setStorageUnit(newUnit);
    if (storageValue) {
      onStorageChange(name, storageValue, newUnit);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        marginBottom: "15px",
        gap: "12px",
        opacity: disabled ? 0.6 : 1,
      }}
    >
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        style={{
          width: isMainModule ? "36px" : "32px",
          height: isMainModule ? "36px" : "32px",
          cursor: disabled ? "not-allowed" : "pointer",
          accentColor: isMainModule ? "#3498db" : "",
        }}
        id={`chk_${name}`}
      />
      <label
        htmlFor={`chk_${name}`}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          fontSize: isMainModule ? "18px" : "16px",
          fontWeight: isMainModule ? "600" : "400",
          userSelect: "none",
        }}
      >
        {label}
      </label>

      {/* Count Input with increment/decrement arrows */}
      {showCountButton && (
        <div
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <span
            style={{
              marginRight: "5px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Count:
          </span>
          <input
            type="number"
            placeholder="Enter count"
            value={countValue}
            disabled={disabled || !checked}
            onChange={onCountChange}
            min="1"
            style={{
              backgroundColor: "#fff",
              color: "#4a4a4d",
              borderRadius: "8px",
              border: "1px solid #cbd5e0",
              padding: "6px 10px",
              fontSize: "14px",
              fontWeight: "500",
              width: "100px",
              textAlign: "center",
              cursor: disabled || !checked ? "not-allowed" : "text",

            }}
          />
        </div>
      )}

      {/* Storage Size with Unit Dropdown */}
      {showStorageSize && (
        <div
          style={{ marginLeft: "auto", display: "flex", alignItems: "center" }}
        >
          <span
            style={{
              marginRight: "5px",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Storage:
          </span>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="number"
              placeholder="Size"
              value={storageValue}
              disabled={disabled || !checked}
              onChange={(e) =>
                onStorageChange(name, e.target.value, storageUnit)
              }
              style={{
                backgroundColor: "#fff",
                color: "#4a4a4d",
                borderRadius: "10px 0 0 10px",
                borderRight: "none",
                border: "1px solid #cbd5e0",
                padding: "6px 10px",
                fontSize: "14px",
                fontWeight: "500",
                width: "80px",
                textAlign: "center",
                cursor: disabled || !checked ? "not-allowed" : "text",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease",
              }}
            />
            <select
              value={storageUnit}
              onChange={handleStorageUnitChange}
              disabled={disabled || !checked}
              style={{
                backgroundColor: "#fff",
                color: "#4a4a4d",
                borderRadius: "0 10px 10px 0",
                border: "1px solid #cbd5e0",
                borderLeft: "none",
                padding: "6px 10px",
                fontSize: "14px",
                fontWeight: "500",
                cursor: disabled || !checked ? "not-allowed" : "pointer",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                transition: "all 0.2s ease",
              }}
            >
              <option value="MB">MB</option>
              <option value="GB">GB</option>
            </select>
          </div>
        </div>
      )}
    </div>
  );
}

export { List };
